module.exports = __webpack_public_path__ + "static/about-fb8491ccb5938fc6bb0fe5e65a5bfab8.svg";